import type { SanityPageBuilderHighlightHeadlineSection, SanityPageBuilderSection } from "@ouster/shared";
import { HighlightHeadlineBlockView } from "~/features/blocks/inventory/highlight-headline";
import { toCraftAsset } from "~/features/sanity/media";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderHighlightHeadlineSection;
  };
};
export function SanityHighlightHeadlineSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  return <HighlightHeadlineBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasScrollHighlighting={sectionContent.hasScrollHighlighting} hasSolidBackground={sectionContent.hasSolidBackground} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} image={toCraftAsset(sectionContent.image)} isBig={sectionContent.isBig} isHighlighted={sectionContent.isHighlighted} link={toCraftLinkArray(sectionContent.link)} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}